const generateSessionId = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
};

export const getSessionHeaders = () => {
  const sessionId = sessionStorage.getItem('sessionId') || sessionStorage.getItem('SessionId');
  return sessionId ? { 'x-session-id': sessionId } : {};
};

export const clearSession = () => {
  sessionStorage.removeItem('sessionId');
  sessionStorage.removeItem('userId');
};